import { KV } from 'types/utils';
import { RobotsContent } from '@navi-toolbox/seo/types/meta-tag/robots';

export type FetchModelProps = {
  regionCode: string;
  pathname: string;
  requiredFields: string;
};

export type BasicLinkProps = {
  label: string;
  link: string;
};

export type GetModelResponse = {
  statusCode: number | null;
} & Partial<GetModelErrorResponse> &
  Partial<{
    visibilityData: GetModelVisibility | null;
    modelJson: ModelJson;
  }>;

export type GetModelErrorResponse = {
  code: string;
  error: string;
  message: string;
};

export type GetModelVisibility = {
  responseStatus: number | null;
  visibility: boolean | null;
  visibilityErrors: {
    message: string;
  }[];
};

export type RegionModel = {
  regionId: string;
  regionCode: string;
  regionName: string;
  currentPageLink: string;
};

export type StretchBannerModel = {
  gaName: string;
  gaPosition: string;
  height: number;
  width: number;
  placementId: string;
  closeButton: boolean;
  autohide: boolean;
  autohideViews: number;
  targetBlank: boolean;
  viewingTime: number;
};

export type KindAnchor = {
  text: string;
  href: string;
  target?: string;
};

export type KindDivisionsList = string[];

export type KindSourceList = string[];

export type YaSplitInfo = {
  availablePaymentMethods: string[];
  hideWidgetHeader: boolean;
  src: string;
  enabled: boolean;
  env: string;
  version: number;
  merchantId: string;
  mainText: string;
  priceBreakThreshold: number;
  maxPriceThreshold: number;
  splitCount: number;
  linkPage: KindAnchor;
  logoLink: string;
  KindDivisionsList: KindDivisionsList;
  KindSourceList: KindSourceList;
};

export type ModelJson = {
  properties: {
    title: string;
    regionId: string;
    familyId: string;
    hideBreadcrumbs: boolean;
    params: KV | null;
    sort: KV | null;
    facetWrapNumber: string;
  };
  seoProperties: SEOProperties;
  experiments?: Experiment[];
  header: {
    register: string;
    account: string;
    advices: string;
    shops: string;
    suppliers: string;
    faq: string;
    home: string;
    shoppingList: string;
    hideMobileRegion: boolean | null;
    hideBreadcrumbs: boolean;
    hideTopBanner: boolean | null;
    logoutUrl: string;
    logoutResource: string;
    initUrl: string;
    forgotPassword: string;
    logoImage: string;
    faviconImage: string;
    linkToCompare: string;
    linkToSearch: string;
    cookieLink: string;
    linkToShoppingList: string;
    recaptchaPublicKey: string;
  };
  breadcrumbs: Breadcrumb[];
  brand: {
    label: string | null;
    logo: {
      originalLink: string | null;
      cloudinaryLink: string | null;

      leftsideImgSrc?: string;
      rightsideImgSrc?: string;
    };
    pagePath: string | null;
  };
  analytics?: {
    gtmCode?: string;
    yaCode?: string;
  };
  warningMessage: string | null;
  regions: RegionModel[];
  rmBannerRastyazhka?: StretchBannerModel;
  yaSplitInfo?: YaSplitInfo;
};

export type SEOProperties = {
  metadescription: string | null;
  metakeywords: string | null;
  seotext: string | null;
  pageTitle: string;
  h1: string;
  canonicalURL: string | null;
  seoTemplate: string;
  vanityPath: string | null;
  canonicalURLNeeded: boolean;
  metaRobotsContent?: RobotsContent[];
};

export const AllowedSEOTemplates = [
  'h1',
  'metadescription',
  'metakeywords',
  'pageTitle',
  'seotext',
] as const;
export type PopulateSeoTemplatesFor = (typeof AllowedSEOTemplates)[number];
export type SEOTemplates = Partial<Record<PopulateSeoTemplatesFor, string>>;
export type SeoTemplateVariables = 'displayedName' | 'price' | 'parent' | 'parent_link' | 'LMCode';

export type Breadcrumb = BasicLinkProps;

export type Experiment = {
  internalId: string;
  externalId?: string;
};
